import { Doc } from '@dadohr/shared/domainTypes/document';
import {
  IExperience,
  PARTICIPANT_ACTOR_KEY
} from '@dadohr/shared/domainTypes/experience';
import { IUser } from '@dadohr/shared/domainTypes/user';

export type D = {
  exp: Doc<IExperience>;
  actors: { [actorKey: string]: Doc<IUser> | null };
};

export const withActorOrNull = <T extends unknown>(
  d: D,
  actor: string,
  fn: (user: Doc<IUser>) => T
): T | null => {
  const a = d.actors[actor];
  return a ? fn(a) : null;
};

export const withParticipantOrNull = <T extends unknown>(
  d: D,
  fn: (user: Doc<IUser>) => T
): T | null => withActorOrNull(d, PARTICIPANT_ACTOR_KEY, fn);
